import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridCellButtonComponent } from './ag-grid-cell-button/ag-grid-cell-button.component';
import {AppMaterialModule} from "../appMaterial/app-material.module";

@NgModule({
    declarations: [
        AgGridCellButtonComponent,
    ],
    imports: [
        CommonModule,
        AppMaterialModule
    ]
})
export class AgGridComponentsModule { }
